var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerfectsvg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "101.583px",
    height: "101.334px",
    viewBox: "23.083 26.666 101.583 101.334",
    enableBackground: "new 23.083 26.666 101.583 101.334",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pool_2_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M23.815,119.387 c8.34,0,8.34,8.01,16.683,8.01c8.338,0,8.338-8.01,16.676-8.01c8.34,0,8.34,8.01,16.678,8.01c8.341,0,8.341-8.01,16.684-8.01 c8.354,0,8.354,8.01,16.71,8.01s8.355-8.01,16.711-8.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M71.709,49.374 v-8.707c0-7.212-5.849-13.063-13.063-13.063c-7.213,0-13.062,5.852-13.062,13.063v69.662"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M123.957,49.374 v-8.707c0-7.212-5.85-13.063-13.063-13.063c-7.215,0-13.063,5.852-13.063,13.063v69.662"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 45.585,
    y1: 66.79,
    x2: 97.833,
    y2: 66.79
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 45.585,
    y1: 92.915,
    x2: 97.833,
    y2: 92.915
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfectsvg3);
export default __webpack_public_path__ + "static/media/perfectsvg3.35ece3c7015aa45bd71a793e28fa47d3.svg";
export { ForwardRef as ReactComponent };